import {booleanComponent, createColumn, defaultColumns, fileField, inputTextField, relationField} from '../_defaults/columns'
import {DateTime} from '../../utils/dateHelpers'
import {dateFormat} from '../../plugins/filters'

export const columns = [
  createColumn({
    label: 'Name',
    isTitle: true,
    field: 'name',
    component: inputTextField({ req: true, max: 255 })
  }),
  createColumn({
    label: 'Guest',
    field: 'guestData',
    type: 'boolean',
    defaultValue: null,
    component: booleanComponent,
    visible: false,
    searchable: false,
    filterable: false,
    sortable: false,
    description: 'This company does not show in normal searches. The record was generated from event registration, donation, or purchase.'
  }),
  createColumn({
    label: 'YourMembership ID',
    field: 'oldYmId',
    type: 'number',
    visible: false,
    defaultValue: null,
    clearValue: null,
    component: null
  }),
  fileField({
    label: 'Logo',
    req: false,
    visible: false,
    field: 'logoUrl',
    mediaCollection: 'logo'
  }),
  createColumn({
    label: 'Membership',
    field: 'membership',
    section: 'Membership',
    visible: false,
    filterable: false,
    searchable: false,
    deepKey: 'description',
    ...relationField({
      type: 'one',
      localKey: 'membershipId',
      namespace: 'membership',
      filterIs: 'text-filter',
      parentRestraint: false,
      props: {
        showSearch: false,
        showBrowse: false
      }
    })
  }),
  createColumn({
    // FAKE FIELD
    label: 'Is Active Member',
    field: 'isActive',
    noSave: true,
    formDisplay: false,
    displayValue: obj => {
      if (obj && obj.isActive) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    ...relationField({
      type: 'one',
      namespace: 'membership',
      localKey: 'id',
      fk: 'membershipId',
      fieldType: 'boolean',
      is: 'q-select',
      filterIs: 'select-filter',
      label: 'isActive',
      props: {
        options: [
          {
            label: 'Yes',
            value: 1
          },
          {
            label: 'No',
            value: 0
          }
        ]
      }
    })
  }),
  createColumn({
    // FAKE FIELD
    label: 'Membership Type',
    field: 'membershipType',
    formDisplay: false,
    noSave: true,
    displayValue: obj => {
      if (obj && obj.membershipType && obj.membershipType.description) {
        return obj.membershipType.description
      } else {
        return ''
      }
    },
    ...relationField({
      type: 'one',
      namespace: 'membership',
      localKey: 'id',
      fk: 'membershipId',
      fieldType: 'number',
      directSearch: 'Membership/membershipTypeId',
      label: 'description',
      filterIs: 'select-filter',
      props: {
        showBrowse: false,
        options: [
          {
            label: 'Specialty Contractor',
            value: 1
          },
          {
            label: 'General Contractor',
            value: 2
          },
          {
            label: 'Affiliate',
            value: 3
          }
        ]
      }
    })
  }),
  createColumn({
    label: 'Affiliate Type',
    field: 'affiliateType',
    section: 'Affiliate Info',
    ...relationField({
      type: 'one',
      label: 'name',
      namespace: 'affiliateType',
      filterIs: 'select-one-field',
      props: { allowEdit: false }
    })
  }),
  // createColumn({
  //   label: 'General & Specialty Work Types',
  //   field: 'companyWorkType',
  //   visible: false,
  //   section: 'General/Specialty Contractor Info',
  //   ...relationField({
  //     type: 'many',
  //     linkTable: true,
  //     fk: 'company',
  //     localKey: 'id',
  //     namespace: 'workType',
  //     filterIs: 'select-many-field',
  //     label: 'description',
  //     parentRestraint: true,
  //     props: { allowEdit: false }
  //   })
  // }),
  createColumn({
    // FAKE FIELD
    label: 'Year Joined',
    field: 'yearJoined',
    formDisplay: false,
    noSave: true,
    displayValue: obj => {
      if (obj && obj.yearJoined) {
        return obj.yearJoined
      } else {
        return ''
      }
    },
    ...relationField({
      type: 'one',
      namespace: 'membership',
      localKey: 'id',
      fk: 'membershipId',
      fieldType: 'number',
      label: 'yearJoined'
    })
  }),
  createColumn({
    // FAKE FIELD
    label: 'Membership Expiration',
    field: 'membershipExpiration',
    formDisplay: false,
    filterIs: 'date',
    type: 'date',
    noSave: true,
    sortable: false,
    displayValue: obj => {
      if (obj && obj.membershipPeriod) {
        let membershipExpiration = obj.membershipPeriod.reduce((accumulator, currentValue) => {
          if (currentValue && currentValue.expiryDate) {
            return dateFormat(currentValue.expiryDate, 'MMM DD YYYY') + ', '
          }
        }, '')
        if (membershipExpiration) {
          return membershipExpiration.slice(0, -2)
        }
      }
    },
    ...relationField({
      is: 'q-datetime',
      linkTable: true,
      sortable: false,
      directSearch: 'Membership/membershipPeriod/any(a:a/expiryDate',
      fieldType: 'date',
      type: 'one',
      namespace: 'membership',
      localKey: 'companyId',
      fk: 'id'
    })
  }),
  createColumn({
    label: 'Contact Type',
    field: 'contactType',
    // type: 'select-one',
    searchType: 'notNull',
    noSave: true,
    formDisplay: false,
    component: {
      // fieldType: 'notNull',
      is: 'q-select',
      filterIs: 'select-filter',
      props: {
        options: [
          {
            label: 'Primary',
            value: 'primaryPersonId'
          },
          {
            label: 'Billing',
            value: 'billingPersonId'
          },
          {
            label: 'Safety',
            value: 'safetyPersonId'
          },{
            label: 'Chase',
            value: 'chasePersonId'
          },
          {
            label: 'HR',
            value: 'hrPersonId'
          },
          {
            label: 'Marketing',
            value: 'marketingPersonId'
          },
          {
            label: 'In House Counsel',
            value: 'counselPersonId'
          },
          {
            label: 'Business Development',
            value: 'businessDevPersonId'
          },
          {
            label: 'Estimator 1',
            value: 'estimatorPersonId'
          },
          {
            label: 'Estimator 2',
            value: 'estimator2PersonId'
          },
          {
            label: 'Project Manager 1',
            value: 'projectManagerPersonId'
          },
          {
            label: 'Project Manager 2',
            value: 'projectManager2PersonId'
          },
          {
            label: 'Labor',
            value: 'laborPersonId'
          }
        ]
      }
    }
  }),
  createColumn({
    label: 'Primary Contact',
    field: 'primaryPerson',
    section: 'Primary Contact',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      namespace: 'person',
      filterIs: 'text-filter',
      saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      props: {
        filter: {
          path: 'personCompanies.companyId',
          value: context => context.parentId
        }
      }
    })
  }),
  createColumn({
    label: 'Mailing Address',
    field: 'mailingAddress',
    section: 'Locations',
    ...relationField({
      type: 'one',
      namespace: 'address',
      localKey: 'mailingAddressId',
      searchColumns: ['line1', 'city', 'state/code', 'state/name'],
      orderBy: 'line1',
      label: 'line1'
    })
  }),
  createColumn({
    label: 'Physical Address',
    field: 'address',
    section: 'Locations',
    visible: false,
    ...relationField({
      type: 'one',
      namespace: 'address',
      localKey: 'addressId',
      searchColumns: ['line1', 'city', 'state/code', 'state/name'],
      orderBy: 'line1',
      label: 'line1'
    })
  }),
  createColumn({
    // TODO: SEARCH BY line one, city, state
    label: 'Locations',
    field: 'companyLocation',
    section: 'Locations',
    ...relationField({
      type: 'many',
      filterable: false,
      linkTable: true,
      fk: 'companyId',
      localKey: 'id',
      namespace: 'address',
      filterIs: 'text-filter',
      parentRestraint: true,
      searchColumns: ['line1', 'city', 'state/code', 'state/name'],
      label: 'line1'
    })
  }),
  createColumn({
    label: 'Phone',
    field: 'phoneNumber',
    section: 'Company Contact Info',
    component: inputTextField({ req: false, max: 255, type: 'tel' })
  }),
  createColumn({
    label: 'Fax',
    field: 'faxNumber',
    section: 'Company Contact Info',
    component: inputTextField({ req: false, max: 255, type: 'tel' })
  }),
  createColumn({
    label: 'Website',
    field: 'url',
    section: 'Company Contact Info',
    component: inputTextField({ req: false, max: 255, type: 'url' })
  }),
  createColumn({
    label: 'Profile',
    isTitle: true,
    visible: false,
    field: 'profile',
    section: 'About',
    component: inputTextField({ type: 'textarea', req: false, max: 8192 })
  }),
  // createColumn({
  //   label: 'Directory Names and Titles',
  //   isTitle: true,
  //   visible: false,
  //   field: 'directoryNameTitle',
  //   section: 'About',
  //   component: inputTextField({ type: 'textarea', req: false })
  // }),
  createColumn({
    label: 'Year Founded',
    field: 'yearFounded',
    section: 'About',
    component: inputTextField({ type: 'number', req: false, max: 4 })
  }),
  createColumn({
    label: 'Affiliate Services',
    field: 'companyProductService',
    section: 'Affiliate Info',
    ...relationField({
      type: 'many',
      linkTable: true,
      fk: 'company',
      localKey: 'id',
      namespace: 'productService',
      filterIs: 'select-many-field',
      label: 'name',
      parentRestraint: true,
      props: { allowEdit: false }
    })
  }),
  createColumn({
    label: 'Supply/Provide Services To',
    field: 'companySupplyProvideService',
    filterIs: 'select-one-field',
    section: 'More',
    ...relationField({
      type: 'many',
      linkTable: true,
      fk: 'company',
      localKey: 'id',
      namespace: 'supplyProvideService',
      label: 'name',
      filterIs: 'select-many-field',
      directSearch: 'companySupplyProvideService/supplyProvideServiceId',
      fieldType: 'number',
      parentRestraint: true,
      props: { allowEdit: false }
    })
  }),
  createColumn({
    label: 'Primary Area of Construction',
    field: 'companyPrimaryAreaOfConstruction',
    filterIs: 'select-one-field',
    section: 'More',
    ...relationField({
      type: 'many',
      linkTable: true,
      fk: 'company',
      localKey: 'id',
      namespace: 'primaryAreaOfConstruction',
      label: 'name',
      filterIs: 'select-many-field',
      directSearch: 'companyPrimaryAreaOfConstruction/primaryAreaOfConstructionId',
      fieldType: 'number',
      parentRestraint: true,
      props: { allowEdit: false }
    })
  }),
  createColumn({
    label: 'Division',
    field: 'companyDivision',
    filterIs: 'select-one-field',
    section: 'More',
    ...relationField({
      type: 'many',
      linkTable: true,
      fk: 'company',
      localKey: 'id',
      namespace: 'division',
      label: 'name',
      filterIs: 'select-many-field',
      directSearch: 'companyDivision/divisionId',
      fieldType: 'number',
      parentRestraint: true,
      props: { allowEdit: false }
    })
  }),
// createColumn({
  //   label: 'CSI Codes',
  //   field: 'companyCsiCodes',
  //   filterIs: 'select-one-field',
  //   section: 'More',
  //   ...relationField({
  //     type: 'many',
  //     linkTable: true,
  //     fk: 'company',
  //     localKey: 'id',
  //     namespace: 'csiCodes',
  //     label: 'description',
  //     filterIs: 'select-many-field',
  //     directSearch: 'companyCsiCodes/csiCodesId',
  //     directSearch: 'companyCsiCodes/csiCodesId',
  //     fieldType: 'number',
  //     parentRestraint: true,
  //     props: { allowEdit: false }
  //   })
  // }),
  createColumn({
    label: 'CSI Codes',
    field: 'companyCsiCodes',
    section: 'More',
    ...relationField({
      type: 'many',
      linkTable: true,
      fk: 'company',
      localKey: 'id',
      namespace: 'csiCodes',
      filterIs: 'select-many-field',
      label: 'description',
      parentRestraint: true,
      props: { allowEdit: false }
    })
  }),
  createColumn({
    label: 'Union Status',
    section: 'More',
    field: 'unionStatus',
    type: 'boolean',
    component: booleanComponent
  }),
  createColumn({
    label: 'Minority, Woman, or Veteran Owned Business',
    field: 'minorityWomanVeteranBusiness',
    section: 'More',
    type: 'boolean',
    component: booleanComponent
  }),
  createColumn({
    label: 'AGCA Id',
    field: 'agcaIdentifier',
    section: 'More',
    component: inputTextField({ req: false, max: 255 })
  }),
  createColumn({
    label: 'Certified DBE',
    field: 'certifiedDbe',
    section: 'More',
    type: 'boolean',
    component: booleanComponent
  }),
  createColumn({
    label: 'Billing Contact',
    field: 'billingPerson',
    section: 'Points of Contact',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      namespace: 'person',
      filterIs: 'text-filter',
      saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      props: {
        filter: {
          path: 'personCompanies.companyId',
          value: context => context.parentId
        }
      }
    })
  }),
  createColumn({
    label: 'Safety Contact',
    field: 'safetyPerson',
    section: 'Points of Contact',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      namespace: 'person',
      filterIs: 'text-filter',
      saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      props: {
        filter: {
          path: 'personCompanies.companyId',
          value: context => context.parentId
        }
      }
    })
  }),
  createColumn({
    label: 'Chase Contact',
    field: 'chasePerson',
    section: 'Points of Contact',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      namespace: 'person',
      filterIs: 'text-filter',
      saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      props: {
        filter: {
          path: 'personCompanies.companyId',
          value: context => context.parentId
        }
      }
    })
  }),
  createColumn({
    label: 'HR Contact',
    field: 'hrPerson',
    section: 'Points of Contact',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      namespace: 'person',
      filterIs: 'text-filter',
      saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      props: {
        filter: {
          path: 'personCompanies.companyId',
          value: context => context.parentId
        }
      }
    })
  }),
  createColumn({
    label: 'Marketing Contact',
    field: 'marketingPerson',
    section: 'Points of Contact',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      namespace: 'person',
      filterIs: 'text-filter',
      saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      props: {
        filter: {
          path: 'personCompanies.companyId',
          value: context => context.parentId
        }
      }
    })
  }),
  createColumn({
    label: 'In House Counsel Contact',
    field: 'counselPerson',
    section: 'Points of Contact',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      namespace: 'person',
      filterIs: 'text-filter',
      saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      props: {
        filter: {
          path: 'personCompanies.companyId',
          value: context => context.parentId
        }
      }
    })
  }),
  createColumn({
    label: 'Business Development Contact',
    field: 'businessDevPerson',
    section: 'Points of Contact',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      namespace: 'person',
      filterIs: 'text-filter',
      saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      props: {
        filter: {
          path: 'personCompanies.companyId',
          value: context => context.parentId
        }
      }
    })
  }),
  createColumn({
    label: 'Estimator Contact 1',
    field: 'estimatorPerson',
    section: 'Points of Contact',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      namespace: 'person',
      filterIs: 'text-filter',
      saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      props: {
        filter: {
          path: 'personCompanies.companyId',
          value: context => context.parentId
        }
      }
    })
  }),
  createColumn({
    label: 'Estimator Contact 2',
    field: 'estimator2Person',
    section: 'Points of Contact',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      namespace: 'person',
      filterIs: 'text-filter',
      saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      props: {
        filter: {
          path: 'personCompanies.companyId',
          value: context => context.parentId
        }
      }
    })
  }),
  createColumn({
    label: 'Project Manager Contact 1',
    field: 'projectManagerPerson',
    section: 'Points of Contact',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      namespace: 'person',
      filterIs: 'text-filter',
      saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      props: {
        filter: {
          path: 'personCompanies.companyId',
          value: context => context.parentId
        }
      }
    })
  }),
  createColumn({
    label: 'Project Manager Contact 2',
    field: 'projectManager2Person',
    section: 'Points of Contact',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      namespace: 'person',
      filterIs: 'text-filter',
      saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      props: {
        filter: {
          path: 'personCompanies.companyId',
          value: context => context.parentId
        }
      }
    })
  }),
  createColumn({
    label: 'Labor Contact',
    field: 'laborPerson',
    section: 'Points of Contact',
    ...relationField({
      type: 'one',
      label: context => (context ? `${context.firstName || ''} ${context.lastName || ''}` : ''),
      namespace: 'person',
      filterIs: 'text-filter',
      saveBeforeAndAfter: true,
      searchColumns: ['firstName', 'lastName', 'title'],
      orderBy: 'lastName',
      props: {
        filter: {
          path: 'personCompanies.companyId',
          value: context => context.parentId
        }
      }
    })
  }),
  createColumn({
    // FAKE FIELD
    label: 'MN House District',
    field: 'stateHouseDistrict',
    formDisplay: false,
    noSave: true,
    displayValue: obj => {
      if (obj && obj.stateHouseDistrict) {
        return obj.stateHouseDistrict
      } else {
        return ''
      }
    },
    ...relationField({
      type: 'one',
      namespace: 'address',
      localKey: 'addressId',
      label: 'stateHouseDistrict',
      fk: 'companyId'
    })
  }),
  createColumn({
    // FAKE FIELD
    label: 'MN Senate District',
    field: 'stateSenateDistrict',
    formDisplay: false,
    noSave: true,
    displayValue: obj => {
      if (obj && obj.stateSenateDistrict) {
        return obj.stateSenateDistrict
      } else {
        return ''
      }
    },
    ...relationField({
      type: 'one',
      namespace: 'address',
      localKey: 'addressId',
      label: 'stateSenateDistrict',
      fk: 'companyId'
    })
  }),
  createColumn({
    // FAKE FIELD
    label: 'US Congressional District',
    field: 'federalHouseDistrict',
    formDisplay: false,
    noSave: true,
    displayValue: obj => {
      if (obj && obj.federalHouseDistrict) {
        return obj.federalHouseDistrict
      } else {
        return ''
      }
    },
    ...relationField({
      type: 'one',
      namespace: 'address',
      localKey: 'addressId',
      label: 'federalHouseDistrict',
      fk: 'companyId'
    })
  }),
  createColumn({
    label: 'CAF/IPF',
    field: 'cafIpfValue',
    section: 'CAF/IPF',
    type: 'number',
    // component: inputTextField({ type: 'number', req: false, max: 10, money: true })
    defaultValue: null,
    clearValue: null
  }),
  createColumn({
    label: 'CAF/IPF Year',
    field: 'cafIpfYear',
    section: 'CAF/IPF',
    type: 'number',
    // component: inputTextField({ type: 'number', req: false, max: 4 })
    defaultValue: null,
    clearValue: null
  }),
  createColumn({
    label: 'Advocacy Initiatives Amount',
    field: 'advocacyInitiativesAmount',
    section: 'Advocacy Initiatives',
    type: 'number',
    defaultValue: null,
    clearValue: null
  }),
  createColumn({
    label: 'Advocacy Initiatives Year',
    field: 'advocacyInitiativesYear',
    section: 'Advocacy Initiatives',
    type: 'number',
    defaultValue: null,
    clearValue: null
  }),
  createColumn({
    label: 'Chase Level 1',
    field: 'chaseLevel1Value',
    type: 'boolean',
    section: 'Chase Level',
    component: booleanComponent
  }),
  createColumn({
    label: 'Chase Level 2',
    field: 'chaseLevel2Value',
    type: 'boolean',
    section: 'Chase Level',
    component: booleanComponent
  }),
  createColumn({
    label: 'Chase Level 3',
    field: 'chaseLevel3Value',
    type: 'boolean',
    section: 'Chase Level',
    component: booleanComponent
  }),
  createColumn({
    label: 'Annual Inspection Date',
    field: 'chaseLevel3Year',
    section: 'Chase Level',
    type: 'number',
    // component: inputTextField({ type: 'number', req: false, max: 4 })
    defaultValue: null,
    clearValue: null
  }),
  createColumn({
    label: 'Chase Member Since',
    field: 'chaseMemberSince',
    section: 'Chase Level',
    component: inputTextField({ req: false, max: 255 })
  }),
  createColumn({
    label: 'ARTBA',
    field: 'artba',
    section: 'More',
    type: 'boolean',
    component: booleanComponent
  }),
  createColumn({
    label: 'Leadership Blueprint',
    field: 'leadershipBlueprint',
    section: 'Education Programs',
    component: inputTextField({ type: 'textarea', req: false })
  }),
  createColumn({
    label: 'Executive Circle',
    field: 'executiveCircle',
    section: 'Education Programs',
    component: inputTextField({ req: false, max: 255 })
  }),
  createColumn({
    label: 'Blueprint Masters Program',
    field: 'blueprintMastersProgram',
    section: 'Education Programs',
    component: inputTextField({ req: false, max: 255 })
  }),  
  createColumn({
    label: 'Comments',
    field: 'comment',
    section: 'Comments',
    visible: false,
    filterable: false,
    sortable: false,
    factory: function (obj) {
      return { lastUpdate: dateFormat(DateTime().format()), commentText: obj.commentText, removalDate: null, companyId: obj.companyId }
    },
    ...relationField({
      componentIs: 'accordion-field',
      type: 'many',
      fk: 'companyId',
      localKey: 'id',
      namespace: 'comment',
      subtitle: 'commentText',
      parentRestraint: true
    })
  }),
  createColumn({
    label: 'Contract Access',
    field: 'contractAccess',
    type: 'boolean',
    section: 'Contracts',
    component: booleanComponent
  }),
  createColumn({
    label: 'Contract Expiration',
    field: 'contractExpiration',
    section: 'Contracts',
    type: 'date',
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a'
      },
      validation: {
        required: false
      }
    }
  }),
  createColumn({
    label: 'QuickBooks Customer ID',
    field: 'qbCustomerId',
    section: 'Accouting',
    visible: false,
    component: {
      is: 'quickbooks-id'
    }
  }),
  createColumn({
    label: 'Approved',
    field: 'approved',
    type: 'boolean',
    section: 'Status',
    visible: false,
    defaultValue: true,
    component: null
  }),
  createColumn({
    label: 'Date Approved',
    field: 'dateApproved',
    type: 'date',
    section: 'Status',
    visible: false,
    component: null
  }),
  createColumn({
    label: 'Updated',
    field: 'updatedAt',
    visible: false,
    searchable: false,
    type: 'date',
    sortable: true,
    component: null
  }),
  createColumn({
    label: 'Created',
    field: 'createdAt',
    visible: false,
    searchable: false,
    type: 'date',
    sortable: true,
    component: null
  }),
  createColumn({
    label: 'New Record',
    field: 'isNew',
    type: 'boolean',
    section: 'Status',
    visible: false,
    defaultValue: false,
    // component: booleanComponent
    component: null
  }),
  createColumn({
    label: 'GUID',
    field: 'guidId',
    type: 'text',
    section: 'Data Info',
    visible: false,
    holdFromEdit: true,
    component: null
  })
].concat(defaultColumns)
